import { SVGProps, Ref, forwardRef } from 'react';

export const DzenBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M11.956 23.001h.088c4.369 0 6.905-.44 8.701-2.184C22.577 18.967 23 16.414 23 12.062v-.123c0-4.35-.423-6.887-2.255-8.755C18.95 1.44 16.396 1 12.045 1h-.088c-4.369 0-6.906.44-8.702 2.184C1.423 5.034 1 7.588 1 11.939v.123c0 4.35.423 6.887 2.255 8.755 1.779 1.744 4.333 2.184 8.701 2.184"
                fill="#202022"
            />
            <path
                d="M20.38 11.834a.16.16 0 0 0-.151-.157c-3.007-.114-4.837-.498-6.117-1.778-1.283-1.283-1.666-3.115-1.78-6.128a.157.157 0 0 0-.157-.152h-.35a.16.16 0 0 0-.158.152c-.114 3.012-.496 4.845-1.779 6.128-1.281 1.282-3.11 1.664-6.117 1.778a.157.157 0 0 0-.152.157v.35a.16.16 0 0 0 .152.158c3.007.114 4.837.497 6.117 1.777s1.663 3.107 1.778 6.109a.157.157 0 0 0 .157.152h.352a.16.16 0 0 0 .157-.152c.115-3.002.498-4.828 1.778-6.109 1.282-1.281 3.11-1.663 6.118-1.777a.157.157 0 0 0 .151-.158z"
                fill="white"
            />
        </g>
    </svg>
));
DzenBrandSize24Glyph.displayName = 'DzenBrandSize24Glyph';
